import script from "./CookieModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieModal.vue?vue&type=script&setup=true&lang=js"

import "./CookieModal.vue?vue&type=style&index=0&id=7f040a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f040a22"]])

export default __exports__